import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Partner with ShipSticks',
  description:
    "Partner with us to offer premium, hassle-free shipping. It's easy to implement, " +
    'free to join, and backed by support every step of the way.',
  alternates: {
    canonical: 'https://www.shipsticks.com/partnership-benefits',
  },
}

export default metadata
